import { useEffect } from 'react';
import { reduce, isEmpty, join } from 'lodash';
import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';

import { useGlobalResponseInterceptor } from '../../services/ApiDataService';
import useInterval from '../../utilities/UseInterval';
import { usePlmService } from '../../services/PlmService';
import { usePlms, DOWN, TIMEOUT } from '../../stores/PlmStateStore';
import useIsPrinting from '../../utilities/PrintUtilities';
import useAlerts from '../../stores/AlertsStore';
import { getLogger } from '../../utilities/UseLog';

const PGM_META_KEY = 'plmInfo';
const log = getLogger('PlmsListProvider');

export default function AppPlmsListProvider(props) {
    const { children } = props;

    const plmService = usePlmService();
    const [, /* Not used */ plmActions] = usePlms();
    const [, /* Not used */ alertActions] = useAlerts();
    const isPrinting = useIsPrinting();

    useInterval(() => plmService.getPlms().then(plmActions.addPlms), 30000);
    useEffect(() => {
        plmService.getPlms().then(plmActions.addPlms);
    }, [plmService, plmActions]);

    useGlobalResponseInterceptor('plm-status', (body) => {
        if (body?.[PGM_META_KEY]) {
            plmActions.addStatuses(body[PGM_META_KEY]);
            log.debugTable(body[PGM_META_KEY]);

            if (isPrinting) {
                const unavailablePlmList = reduce(
                    body[PGM_META_KEY],
                    (list, { state }, name) => {
                        return state === DOWN || state === TIMEOUT ? [...list, name] : list;
                    },
                    []
                );
                if (!isEmpty(unavailablePlmList)) {
                    const plmsString = join(unavailablePlmList, ', ');
                    const infoMessage = t`The following Local Managers were unavailable: ${plmsString}`;
                    alertActions.createInfoAlert(i18n._(infoMessage));
                }
            }
        }
    });

    return children;
}
